module.exports = __webpack_public_path__ + "static/img/logo-sp-white.54b84a01.png";